import { render, staticRenderFns } from "./preview-pdf.vue?vue&type=template&id=15b10a74&scoped=true"
import script from "./preview-pdf.vue?vue&type=script&lang=js"
export * from "./preview-pdf.vue?vue&type=script&lang=js"
import style0 from "./preview-pdf.vue?vue&type=style&index=0&id=15b10a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b10a74",
  null
  
)

export default component.exports